var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLessInfo = function SvgIconLessInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.3,
    height: 2.3,
    viewBox: "0 0 10.3 2.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(571.3 -1128) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 1.15,
    cy: 1.15,
    r: 1.15,
    transform: "translate(1128 569)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 1.15,
    cy: 1.15,
    r: 1.15,
    transform: "translate(1128 565)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 1.15,
    cy: 1.15,
    r: 1.15,
    transform: "translate(1128 561)",
    fill: "#173a6d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLessInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_less_info.6610645c.svg";
export { ForwardRef as ReactComponent };